import {
    PACKAGE_LOADING,
    PACKAGE_ERROR,
    PACKAGE_GET_LIST,
    PACKAGE_RESET_LIST,
    PACKAGE_ADD,
    PACKAGE_GET_IMAGE,
    PACKAGE_GET_UNITS_OF_MEASUREMENT
} from "actions/package/constants";

const initialState = {
    loading: false,
    errors: [],

    packageList: [],
    unitsOfMeasurement: [],
    packageImage: ""
};

export default function(state = initialState, action) {
    let packageList,
        index;
    switch (action.type) {
        case PACKAGE_LOADING:
            return {
                ...state,
                loading: action.payload.content
            };
        case PACKAGE_ERROR:
            return {
                ...state,
                errors: action.payload.content
            };
        case PACKAGE_GET_LIST:
            return {
                ...state,
                loading: false,
                packageList: action.payload.content
            };
        case PACKAGE_RESET_LIST:
            return {
                ...state,
                packageList: []
            };
        case PACKAGE_ADD:
            packageList = Object.assign([], state.packageList);
            index = packageList.findIndex(item => item.id === action.payload.id);
            if (index > -1) {
                packageList[index] = action.payload;
            } else {
                packageList.push(action.payload);
            }
            return {
                ...state,
                loading: false,
                packageList
            };
        case PACKAGE_GET_UNITS_OF_MEASUREMENT:
            return {
                ...state,
                loading: false,
                unitsOfMeasurement: action.payload.content
            };
        case PACKAGE_GET_IMAGE:
            return {
                ...state,
                loading: false,
                packageImage: action.payload.content
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/packageReducer.js